/**
 * @file _form-reserve.js
 */
'use strict';
import Common from '../../util/_common';

/**
 * @classname FormReserve
 * @classdesc 予約フォーム
 */
export default class FormReserve {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof Sample
	 * @return {undefined}
	 */
	preProcessing($form) {
		console.log('FormReserve.preProcessing');
		// バリデーション前に行う処理を記載（開始）
	};


	/**
	 * フォーム送信後処理
	 *
	 * @memberof Sample
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log('FormReserve.postProcessing');
		// バリデーション後に行う処理を記載（開始）

		// 名前の統合
		$('.user_name').val(`${$('.user_name1').val()} ${$('.user_name2').val()}`);
		// 名前カナの統合
		$('.user_name_kana').val(`${$('.user_name_kana1').val()} ${$('.user_name_kana2').val()}`);

		const shopId = $('#shop_id').val();
		console.log(shopId);
		const card = {
			no		: $('#maskcard').val(),
			expire	: `${$('#card_year').val()}${$('#card_month').val()}`,
			holder	: $('.card_holder').val(),
			code	: $('.card_code').val()
		};
		console.log(card);
		Multipayment.init(shopId);
		Multipayment.getToken({
			cardno      : card['no'],
			expire      : card['expire'],
			holdername	: card['holder'],
			securitycode: card['code'],
			tokenumber	: 1
		}, getTokenCallback);

		// バリデーション後に行う処理を記載（終了）
		this._controller.waitCallback();
		//this._controller.completePostProcessing($form);
	};
}
